import React from 'react'
import {
  LoadingContainer,
  RowWrapper,
  UserProfileSection,
  UserInfoSection,
  Info,
  AvatarPlacerholder,
  NamePlaceholder,
  AccountCreationDatePlaceholder,
  DataPlacerholder,
} from './styling'

const Loading = () => {
  return (
    <LoadingContainer>
      <RowWrapper>
        <UserProfileSection>
          <UserInfoSection>
            <AvatarPlacerholder />
            <Info>
              <NamePlaceholder />
              <AccountCreationDatePlaceholder />
            </Info>
          </UserInfoSection>
          <DataPlacerholder />
        </UserProfileSection>
      </RowWrapper>
    </LoadingContainer>
  )
}

export default Loading
